import React from "react"
import {useForm, ValidationError} from '@formspree/react'
import {useTranslation} from "react-i18next";
import { SocialIcon } from 'react-social-icons';
import ambassadorPicture from './../Assets/optilume_ambassador_8.png'
import CardMedia from "@material-ui/core/CardMedia";
import {Link} from 'react-router-dom'


const ContactForm = () => {
    const [state, handleSubmit] = useForm("xdoybrbl")

    const { t } = useTranslation()


    if (state.succeeded) {
        return <p>{t('messageSent')}</p>
    }

    return (
        <section id="contact">
            <div className="row">
                <div className="eight columns">
                    <form onSubmit={handleSubmit} id="contactForm">
                        <label htmlFor="full_name">
                            {t('name')}
                        </label>
                        <input type="text"
                               name="full_name"
                               id="full_name"
                               placeholder={t('name')}
                        />
                        <ValidationError errors={state.errors} prefix="FullName" field="full_name"/>
                        <label htmlFor="email">
                            {t('email')}
                        </label>
                        <input
                            id="email"
                            type="email"
                            name="email"
                            placeholder={t('email')}
                        />
                        <ValidationError
                            prefix="Email"
                            field="email"
                            errors={state.errors}
                        />
                        <label htmlFor="message">
                            {t('messageTheme')}
                        </label>
                        <textarea
                            id="message"
                            name="message"
                            placeholder={t('messageTheme')}
                        />
                        <ValidationError
                            prefix="Message"
                            field="message"
                            errors={state.errors}
                        />


                        <button type="submit" disabled={state.submitting}>
                            {t('send')}
                        </button>


 
                    </form>
                </div>



                <aside className="four columns footer-widgets">
                    <div className="widget widget_contact">
                        <h4>{t('addressAndPhone')}</h4>
                        <p className="address">
                            Mannheim Urology<br/>
                            Seckenheimer Haupstrasse 143 <br/>
                            Mannheim, Germany 68239<br/>
                            <span>+49 176 62705484</span><br/>
                            <a href = "mailto: contact@mannheim-urology.com">contact@mannheim-urology.com</a>
                              <h3> Follow us on social media</h3>                      
                        </p>

                        <SocialIcon url="https://www.instagram.com/mannheim_urology/" target="_blank" rel="noopener noreferrer"/>   
                        <h3> </h3> 
                        <SocialIcon url="https://twitter.com/OTosev" target="_blank" rel="noopener noreferrer"/>

                    </div>
                </aside>

               <div >

                <CardMedia
                    component='img'
                    image={"https://cdn.mannheim-urology.com/logos/logos.png"}
                    style={
                        {
                            width: '100%',
                            objectFit: 'inherit',
                            objectPosition: 'bottom',
                            marginLeft: '3%',
                            marginTop: '3%',
                        }}
                />

                </div>

            </div>
        </section>
    )
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/Components/ContactForm.js